var map = {
	"./token-1inch.svg": [
		3675,
		675
	],
	"./token-aavaxb.svg": [
		3351,
		351
	],
	"./token-aave.svg": [
		8117,
		117
	],
	"./token-avax.svg": [
		4279,
		279
	],
	"./token-avme.svg": [
		9566,
		566
	],
	"./token-boofi.svg": [
		403,
		403
	],
	"./token-dai.svg": [
		636,
		636
	],
	"./token-eth.svg": [
		5202,
		202
	],
	"./token-joe.svg": [
		5342,
		342
	],
	"./token-link.svg": [
		5986,
		986
	],
	"./token-lyd.svg": [
		3959,
		959
	],
	"./token-maxi.svg": [
		7037,
		37
	],
	"./token-mim.svg": [
		3764,
		764
	],
	"./token-myak.svg": [
		5108,
		108
	],
	"./token-orca.svg": [
		8989,
		989
	],
	"./token-pefi.svg": [
		7944,
		944
	],
	"./token-png.svg": [
		5047,
		47
	],
	"./token-qi.svg": [
		9897,
		897
	],
	"./token-snob.svg": [
		1057,
		57
	],
	"./token-sushi.svg": [
		4937,
		937
	],
	"./token-time.svg": [
		4310,
		310
	],
	"./token-uni.svg": [
		6626,
		626
	],
	"./token-usdc.svg": [
		1752,
		752
	],
	"./token-usdt.svg": [
		5189,
		189
	],
	"./token-vso.svg": [
		9694,
		694
	],
	"./token-wawax.svg": [
		1968,
		968
	],
	"./token-wbtc.svg": [
		6908,
		908
	],
	"./token-xava.svg": [
		8687,
		687
	],
	"./token-yak.svg": [
		4882,
		882
	],
	"./token-yfi.svg": [
		1567,
		567
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4230;
module.exports = webpackAsyncContext;